import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Link, useParams } from "react-router-dom";
import Spinner from "../../../../components/helpers/Spinner";
import { fetchAxiosNoToken } from "../../../../helpers/fetchAxiosNoToken";
import { useAppSelector } from "../../../../hooks/hooks";
import { set_landing_house } from "../../../../redux/reducers/landingReducer";

const PagoConfirmado = () => {
    const dispatch = useDispatch();

    // 1. Obtenemos ambos banners del estado
    const { banner } = useAppSelector((state) => state.landing_house.house);
    const { id: id_corredor, banner: banner_corredor } = useAppSelector(
        (state) => state.corredor,
    );

    const getHouseFromTenant = async () => {
        try {
            const data = await fetchAxiosNoToken({
                url: `/casa/getOne/dominio`,
            });
            dispatch(set_landing_house(data));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getHouseFromTenant();
    }, []);

    // 2. Lógica de prioridad:
    // Si existe 'banner' (casa), usa ese.
    // Si no, usa 'banner_corredor'.
    // Si no hay ninguno, será undefined/null.
    const activeBanner = banner || banner_corredor;

    // Opcional: Si la URL del endpoint cambia para el corredor (ej: /corredor/getImage),
    // deberías hacer un if/else aquí para construir la URL correcta.
    // Por ahora asumo que usan la misma ruta base `/casa/getImage/`.
    const imageUrl = activeBanner
        ? `${process.env.REACT_APP_PROXY}/casa/getImage/${activeBanner}`
        : "";

    return (
        <div className="flex">
            {/* 3. Evaluamos si hay ALGÚN banner activo */}
            {activeBanner ? (
                <div
                    style={{
                        backgroundImage: `url(${imageUrl})`,
                        filter: "brightness( 100% ) contrast( 113% ) saturate( 100% ) blur( 0px ) hue-rotate( 0deg )",
                    }}
                    className={`w-full bg-blue-500 h-screen bg-center bg-no-repeat
                bg-cover flex flex-col text-center`}
                >
                    <div className="h-screen bg-[rgba(5,52,101,0.60)]">
                        <h1 className="p-4 mt-20 text-4xl font-bold text-white lg:text-5xl">
                            ¡Gracias por tu pago!
                        </h1>
                        <h1 className="mt-5 text-xl font-bold text-white lg:text-3xl">
                            Tu pago fue procesado correctamente
                        </h1>
                        <div className="px-10">
                            <div className="flex flex-col max-w-lg py-10 mx-auto mt-10 rounded-lg bg-neutral-200 lg:mt-28 opacity-95">
                                <Link to="/">
                                    <span
                                        className={`font-semibold hover:border hover:underline border-gray-400 bg-blue-500 text-white p-3 min-w-max mx-auto cursor-pointer rounded-md text-lg`}
                                    >
                                        Volver al sitio
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                // 4. Si no hay activeBanner (ni casa ni corredor), muestra Spinner
                <div className="mx-auto mt-20">
                    <Spinner />
                </div>
            )}
        </div>
    );
};

export default PagoConfirmado;
